import React from "react";
import propTypes from "prop-types";
import { Button } from "reactstrap";
import { message } from "antd";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { openNotification } from "../../../../../Components/Notification";

// import moment from 'moment';
import Loader from "../../../../../../Global/Loader";
import CreateContext from "../../store/CreateContext";
import { validateFrequency } from "./utils";
import { Services } from "../../../../../../../repositories/clients/Services";

function SaveReport(props) {
  const context = React.useContext(CreateContext);
  const [updating, setUpdating] = React.useState(false);
  const [isRedirect, setIsRedirect] = React.useState(false);
  const [messageError, setMessageError] = React.useState("");

  /*=============================================
  =            Scheme definition                =
  =============================================*/

  function createOndemandScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,
      module: context.module_selected,
      fields: context.selected_fields,
      filters: context.filters,
      order: context.order_fields,

      emailList: context.emailList,
      customer: props.clients,
      user: localStorage.getItem("dataUser"),
      reportId: reportId,
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }
  function createScheduledScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,

      type: context.config.frequency,
      recurrence:
        context.config.frequency === "Monthly"
          ? context.config.Monthly
          : context.config.Daily,
      startDate: context.config.startDate.value,
      endDate: context.config.endDate.value,
      hour: context.config.hour.value,
      day: Number(context.config.day),
      timeZone: context.config.timeZone,
      timeZoneValue: context.config.timeZoneValue,
      timeZoneStr: context.config.timeZoneStr,

      module: context.module_selected,
      filters: context.filters,
      order: context.order_fields,
      emailList: context.emailList,
      customer: props.clients,
      user: localStorage.getItem("dataUser"),
      fields: context.selected_fields,
      reportId: reportId,
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }

  /*=============================================
  =            Creation Functions               =
  =============================================*/

  const CreateOnDemand = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createOndemandScheme(context);
      // const respCreate =
      await axios.post(
        `${Services.REPORTS.path}reports/builder/create/ondemand`,
        body
      );
      setUpdating(false);
      openNotification('success', props.t("report_success_created"));

      context.model_reset();

      setTimeout(() => { }, 3000);

      setIsRedirect(true);
    } catch (error) {
      setUpdating(false);
      openNotification('error', props.t("error_create_report"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CreateScheduled = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createScheduledScheme(context);
      // const respScheduled =
      await axios.post(
        `${Services.REPORTS.path}reports/builder/create/scheduled`,
        body
      );

      setUpdating(false);
      openNotification('success', props.t("report_success_created"));
      context.model_reset();

      setTimeout(() => { }, 3000);

      setIsRedirect(true);
    } catch (error) {
      setUpdating(false);
      openNotification('error', props.t("error_create_report"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*=============================================
  =            Update Functions            =
  =============================================*/

  const UpdateOnDemand = React.useCallback(
    async (context, reportId, onEvent) => {
      try {
        setUpdating(true);
        const body = createOndemandScheme(context, reportId);
        // const resUpdate =
        await axios.put(
          `${Services.REPORTS.path}reports/builder/update/ondemand`,
          body
        );

        setUpdating(false);
        openNotification('success', props.t("configuration_successfull"));
        setTimeout(() => {
          onEvent();
        }, 1000);
      } catch (error) {
        setUpdating(false);
        openNotification('error', props.t("report_new_error"));
      }
    },
    []
  );

  const UpdateScheduled = React.useCallback(
    async (context, reportId, onEvent) => {
      try {
        setUpdating(true);
        const body = createScheduledScheme(context, reportId);
        // const resUpdate =
        await axios.put(
          `${Services.REPORTS.path}reports/builder/update/scheduled`,
          body
        );
        setUpdating(false);
        openNotification('success', props.t("configuration_successfull"));
        setTimeout(() => {
          onEvent();
        }, 1000);
      } catch (error) {
        setUpdating(false);
        openNotification('error', props.t("error_update_report"));
      }
    },
    []
  );

  function handleSaveReport(type) {
    let valid = true;
    let message = "";

    if (!context.report_name.value) {
      message = props.t("you_must_name");
      if (messageError !== message) {
        openNotification('error', props.t("you_must_name"));
        setMessageError(message);
      }
      valid = false;
    } else if (!context.report_description.value) {
      message = props.t("report_new_description");
      if (messageError !== message) {
        setMessageError(message);
        openNotification('error', props.t("report_new_description"));
      }
      valid = false;
    }

    if (context.report_type === "ondemand") {
      if (!context.selected_fields.length) {
        message = props.t("you_must_select_field");
        if (messageError !== message) {
          openNotification('error', props.t("you_must_select_field"));
          setMessageError(message);
        }
        valid = false;
      }
      if (valid) {
        if (type === "create") {
          CreateOnDemand(context);
        } else {
          UpdateOnDemand(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    } else if (context.report_type === "scheduled") {
      if (context.config.frequency === "Daily") {
        if (!validateFrequency(context.config.Daily)) {
          message = props.t("you_must_frequency_days");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("you_must_frequency_days"));
          }
          valid = false;
        }
        if (!context.config.hour.value) {
          message = props.t("hour_not_valid");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("hour_not_valid"));
          }
          valid = false;
        }
        if (!context.selected_fields.length) {
          message = props.t("you_must_select_field");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("you_must_select_field"));
          }
          valid = false;
        }
      } else if (context.config.frequency === "Monthly") {
        if (!validateFrequency(context.config.Monthly)) {
          message = props.t("month_recurrency_not_selected");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("month_recurrency_not_selected"));
          }
          valid = false;
        }
        if (!context.config.hour.value) {
          message = props.t("valid_time_not_selected");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("valid_time_not_selected"));
          }
          valid = false;
        }
        if (!context.config.day) {
          message = props.t("month_not_selected");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("month_not_selected"));
          }
          valid = false;
        }
        if (!context.selected_fields.length) {
          message = props.t("you_must_select_field");
          if (messageError !== message) {
            setMessageError(message);
            openNotification('error', props.t("you_must_select_field"));
          }
          valid = false;
        }
      } else {
        message = props.t("frecuency_not_selected");
        if (messageError !== message) {
          setMessageError(message);
          openNotification('error', props.t("frecuency_not_selected"));
        }
        valid = false;
      }

      if (valid) {
        if (type === "create") {
          CreateScheduled(context);
        } else {
          UpdateScheduled(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    }
  }

  return (
    <div className="col-md-6 d-flex  justify-content-sm-end justify-content-xs-start justify-content-end col-md-6 col-sm-12 col-xs-12 col-lg-6 col-xl-6">
      {isRedirect ? <Redirect to={"/my-reports"} /> : ""}
      <div>
        {props.action === "create" ? (
          <div className="col-12 row">
            <div className="col-xs-6">
              <Button
                color="secondary"
                onClick={() => props.history.push("/my-reports")}
                className="custom-width-btn"
              >
                {props.t("cancel")}
              </Button>
            </div>
            <div className="col-xs-6">
              <Button
                color="primary"
                onClick={() => handleSaveReport("create")}
                className="custom-width-btn ml-2"
              >
                {props.t("save")}
              </Button>
            </div>
          </div>
        ) : (
          <Button color="primary" onClick={() => handleSaveReport("edit")} className="custom-width-btn">
            {props.t("save")}
          </Button>
        )}
      </div>
      <Loader hidden={!updating}></Loader>
    </div>
  );
}

SaveReport.propTypes = {
  onEvent: propTypes.func,
};
SaveReport.defaultProps = {
  onEvent: () => { },
};

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(SaveReport)));
